import { ComponentProps } from "react";

import AppContextValueProvider from "../../../App/compositions/AppContextValueProvider";
import SchedulingLoader from "../Components/SchedulingLoader";
import ISchedulingLoaderProps from "../types/ISchedulingLoaderProps";

const AppContextSchedulingLoader = AppContextValueProvider<
  ISchedulingLoaderProps,
  ComponentProps<typeof SchedulingLoader>
>({
  Component: SchedulingLoader,
  map: ({ bookingController, patient, reservation, router }) => ({
    bookingController,
    patientFirstName: patient.displayFirstName,
    reservation,
    router
  })
});

export default AppContextSchedulingLoader;
